import Vue from 'vue';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
// import 'echarts/lib/chart/funnel';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/markLine';
import 'echarts/lib/component/graphic';
import 'echarts/lib/component/dataZoom';
import '@ui/funnel/funnel';
Vue.directive('pChart', {
  deep: true,
  inserted: (el, binding) => {
    el.echartsInstance = echarts.init(el);
    el.resizeEventHandler = function () {
      el.echartsInstance.resize();
    };
    if ( window.attachEvent ) {
      window.attachEvent('onresize', el.resizeEventHandler);
    } else {
      window.addEventListener('resize', el.resizeEventHandler, false);
    }
  },
  update: (el, binding) => {
    // 如果配置不设置showLoading时，每次页面update显示loading 否则不显示
    if (binding.value.showLoading === undefined || binding.value.showLoading) {
      el.echartsInstance.showLoading('default',{color:'#4DA5F8'});   
    } else if (!binding.value.showLoading){
    
    }
    Vue.nextTick(() => {
      el.echartsInstance.setOption(binding.value);
      el.echartsInstance.resize();
    });
    setTimeout(() => {
      el.echartsInstance.hideLoading();
    }, 600);
  },
  unbind: (el) => {
    el.echartsInstance.dispose();
    if ( window.attachEvent ) {
      window.detachEvent('onresize', el.resizeEventHandler);
    } else {
      window.removeEventListener('resize', el.resizeEventHandler, false);;
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/core/chart.js